/* global axios */
import ApiClient from './ApiClient';

class WahaSessionAPI extends ApiClient {
  constructor() {
    super('waha_sessions', { accountScoped: true });
  }

  getSessions(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/waha_sessions`);
  }

  getSession(accountId, sessionId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}`
    );
  }

  createSession(accountId, { name, auth_method }) {
    return axios.post(`/api/v1/accounts/${accountId}/waha_sessions`, {
      name,
      auth_method,
    });
  }

  deleteSession(accountId, sessionId) {
    return axios.delete(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}`
    );
  }

  getQRCode(accountId, sessionId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}/qr_code`,
      {
        responseType: 'blob',
      }
    );
  }

  requestPairingCode(accountId, sessionId, phoneNumber) {
    return axios.post(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}/request_code`,
      {
        phone_number: phoneNumber,
      }
    );
  }

  startSession(accountId, sessionId) {
    return axios.post(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}/start`
    );
  }

  stopSession(accountId, sessionId) {
    return axios.post(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}/stop`
    );
  }

  logoutSession(accountId, sessionId) {
    return axios.post(
      `/api/v1/accounts/${accountId}/waha_sessions/${sessionId}/logout`
    );
  }
}

export default new WahaSessionAPI();
